import { cn } from 'utils/cn';

import { BaseButton, ButtonProps } from './Button';

export const SecondaryButton: React.FC<ButtonProps> = props => {
  const className = cn(
    'bg-sf-sec-0-80 hover:bg-sf-sec-hov-0-90 active:bg-sf-sec-pres-0-90 focus-visible:bg-sf-prim-w-90',
    'text-icn-txt-prim overflow-hidden text-ellipsis whitespace-nowrap',
    props.disabled && 'text-icn-txt-tert hover:bg-sf-sec-0-90 active:bg-sf-sec-0-90'
  );

  return <BaseButton {...props} loaderClassName="text-icn-txt-sec" className={cn(className, props.className)} />;
};
